import React from 'react';
import Partners from '../../Components/home/Partners/Partners';
import Hero from '../../Components/home/Hero/Hero';
import Header from '../../Components/Header/Header';
import { hero1, hero2, hero3, hero4, heroVideo, homePattern, servicesPattern } from '../../assets/images';
import News from '../../Components/home/News/News';
import Projects from '../../Components/home/Projects/Projects';
import WhyUs from '../../Components/home/WhyUs/WhyUs';
import Categories from '../../Components/home/Categories/Categories';
import Services from '../../Components/home/Services/Services';
import Solutions from '../../Components/home/Solutions/Solutions';
import Setem from '../../Components/home/Setem/Setem';
import Ethics from '../../Components/home/Ethics/Ethics';
import { useTranslation } from 'react-i18next';



const Home = () => {
  const { t, i18n } = useTranslation();


  return (
    <div className="relative">
      {/* Background pattern */}
      <div
        className="fixed inset-0 z-[-2] bg-cover bg-center"
        style={{
          backgroundImage: `url(${homePattern})`,
        }}
      />

      {/* Video + Overlay + Content */}
      <div className="relative h-screen w-full overflow-hidden">
        {/* Header */}
        <div className="absolute top-0 left-0 w-full z-30">
          <Header />
        </div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/60 z-10" />

        {/* Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Hero content */}
        <div className="relative z-20 h-full flex items-center justify-between px-4 md:px-16">
          {/* Left Side Icons */}
          <div className="flex flex-col items-center justify-center space-y-4 relative top-6">
            <div className="bg-white h-[150px] w-[1px]" />
            {[hero1, hero2, hero3].map((icon, i) => (
              <a
                key={i}
                href="https://www.facebook.com/sharer/sharer.php?u=http://www.akond.az/wp/"
              >
                <img src={icon} alt={`hero${i + 1}`} className="w-6 h-6" />
              </a>
            ))}
            <div className="bg-white h-[150px] w-[1px]" />
          </div>

          {/* Right Side Text */}
          <div className="text-right flex flex-col justify-end items-end h-full pb-10 max-w-[600px]">
            <div className="flex items-center text-white text-[16px] md:text-[30px] font-semibold font-secondFont">
              <p>{t("Rahatlıq və Təhlükəsizlik Üçün Peşəkar Həllər!")}</p>
              <img src={hero4} alt="hero4" className="ml-2 w-5 md:w-9" />
            </div>
          </div>
        </div>
      </div>

      {/* Rest of Page */}
      <div>
        <News />
        <Projects />
        <WhyUs />
        <Categories />
        <Services />
        <Solutions />
        <Setem />
        <Ethics />
        <Partners />
        <div className="h-[100px]" />
      </div>
    </div>
  );
};

export default Home;

 